import { useQuery } from '@tanstack/react-query'
import { dayjs } from '../../lib/time'
import { fetchLunchMeals } from './api'

export function useLunchMeals(baseDateISO: string) {
  const base = dayjs.tz(baseDateISO, 'YYYY-MM-DD', 'Asia/Seoul')
  const fromYmd = base.format('YYYYMMDD')
  const toYmd = base.add(3, 'day').format('YYYYMMDD')

  return useQuery({
    queryKey: ['lunchMeals', fromYmd, toYmd],
    queryFn: () => fetchLunchMeals({ fromYmd, toYmd }),
  })
}

export function listYmd(baseDateISO: string): string[] {
  const base = dayjs.tz(baseDateISO, 'YYYY-MM-DD', 'Asia/Seoul')
  return Array.from({ length: 4 }, (_, i) => base.add(i, 'day').format('YYYYMMDD'))
}

export function ymdToISO(ymd: string): string {
  return dayjs.tz(ymd, 'YYYYMMDD', 'Asia/Seoul').format('YYYY-MM-DD')
}

export function ymdToLabel(ymd: string): { mmdd: string; dow: string } {
  const d = dayjs.tz(ymd, 'YYYYMMDD', 'Asia/Seoul')
  const dowMap = ['일', '월', '화', '수', '목', '금', '토']
  return {
    mmdd: d.format('MM/DD'),
    dow: dowMap[d.day()],
  }
}
